import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { SquarePenIcon } from "lucide-react";
import { useAgentChatContext } from "./context";

export function AgentChatNewChatButton({ className }: { className?: string }) {
  const { actions } = useAgentChatContext();
  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn("h-7 w-7 text-muted-foreground", className)}
      title="New chat"
      onClick={actions.newChat}
    >
      <SquarePenIcon className="h-4 w-4" />
    </Button>
  );
}
